import { render, staticRenderFns } from "./Acessar.vue?vue&type=template&id=3b474047&scoped=true&"
import script from "./Acessar.vue?vue&type=script&lang=js&"
export * from "./Acessar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b474047",
  null
  
)

export default component.exports